import React from 'react';

import {ActionOrigin} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Grid, Storable} from 'constants/SampleConstants';
import preferences from 'Preferences';
import {CoordinatesOrderingKey, GridSortOptionsPreferences} from 'samples/grids/GridCellTableConstants';
import {isFixedPlate} from 'samples/SampleUtil';
import * as StorableActions from 'samples/StorableActions';
import StorableToolbarContents from 'samples/toolbar/StorableToolbarContents';
import {ButtonStyle} from 'ui-library/buttons/Button';
import LegacyDropdownMenuItem from 'ui-library/dropdowns/legacy/LegacyDropdownMenuConstants';
import {SortDirection, TABLE_KEYS} from 'ui-library/scrollable/ScrollableTableConstants';
import APIUtil from 'util/APIUtil';

export interface GridCellToolbarContentsProps {
  buttonStyle: ButtonStyle;
  storables: Array<Storable>;
  grid: Grid;
  selectedIds: Array<string>;
}

const GRID_TABLE_KEY = TABLE_KEYS.GRID_CELL_TABLE;

export default class GridCellToolbarContents extends React.Component<GridCellToolbarContentsProps> {
  private handleExportGridToCSV = (): void => {
    const sortDirection: SortDirection =
      preferences.get(`${GRID_TABLE_KEY}.${GridSortOptionsPreferences.COORDINATES_SORT_DIRECTION}`) ??
      SortDirection.ASCENDING_SORT;
    const positionOrderKey: CoordinatesOrderingKey =
      preferences.get(`${GRID_TABLE_KEY}.${GridSortOptionsPreferences.COORDINATES_ORDER_BY_KEY}`) ??
      CoordinatesOrderingKey.ROW;
    StorableActions.exportGridToCSV(this.props.grid.id, sortDirection, positionOrderKey);
  };

  private getExportMenuItems(): Array<LegacyDropdownMenuItem> {
    const gridType = APIUtil.apiIdToType(this.props.grid.id);
    return [
      {
        name: `Export entire ${gridType} to CSV`,
        handleOnClick: this.handleExportGridToCSV,
        disabled: false,
      },
    ];
  }

  override render(): JSX.Element {
    const gridIsFixedPlate = isFixedPlate(this.props.grid);
    const gridType = APIUtil.apiIdToType(this.props.grid.id);
    return (
      <StorableToolbarContents
        actionOrigin={
          gridType === ModelTypeConstants.PLATE
            ? ActionOrigin.INVENTORY_PLATE_PAGE_GRID_CELL_TOOLBAR
            : ActionOrigin.INVENTORY_BOX_PAGE_GRID_CELL_TOOLBAR
        }
        buttonStyle={this.props.buttonStyle}
        storables={this.props.storables}
        selectedIds={this.props.selectedIds}
        extraExportMenuItems={this.getExportMenuItems()}
        parentStorableForMove={this.props.grid}
        hideCheckInCheckOut={gridIsFixedPlate}
        hideMove={gridIsFixedPlate}
        hideArchive={gridIsFixedPlate}
      />
    );
  }
}
